import * as React from 'react';
import { Alert, Tabs, Col, Row, Modal, Badge } from 'antd';
import { observer } from 'mobx-react';
const TabPane = Tabs.TabPane;
import autobind from 'autobind-decorator';
import { Prompt } from 'react-router';

import { HeaderView } from 'src/app/shared/header.view';
import { IdentityService } from 'src/core/services/identity.service';
import { QuoteGeneralPartController } from './parts/quote-general.controller';
import { QuotePaxController } from 'src/app/bookings/quote-paxs/quote-pax.controller';
import { QuoteEntryController } from 'src/app/bookings/quote-entries/quote-entry.controller';
import { QuotePaxDataService } from 'src/app/bookings/quote-paxs/quote-pax-form.data';
import { NoteListController } from 'src/app/general/notes/list/note-list.controller';
import { QuoteEntryDataService } from 'src/app/bookings/quote-entries/quote-entry-form.data';
import { DocumentGenerationController } from 'src/app/general/document-generation/document-generation.controller';
import { ContextService } from 'src/core/services/context.service';
import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { DataLocalService } from 'src/core/services/data-local.service';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { BooleanView } from 'src/core/ui/boolean.view';
import { QuotePaymentListController } from 'src/app/bookings/quote-payments/quote-payment.controller';
import UserTaskTab  from 'src/app/general/user-tasks/parts/user-tasks-tab.view';
import AuditController from 'src/app/general/audit/audit.controller';
import { ZuluIcon } from 'src/app/shared/icon';
import * as moment from 'moment';


interface QuoteFormViewProps extends ComponentViewProps<QuoteItem> {
	model: QuoteItem;
	entryDataService: QuoteEntryDataService;
	paxDataService: QuotePaxDataService;
	paymentDataSet: DataSet<PaymentSummary>;
	generationEnabled: boolean;
	title: string;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	save: () => Promise<void>;
	cancel: () => void;
	contextService: ContextService;
	defaultLanguage: string;
	formatService: any;
	newQuotePax: (quote: QuoteItem, client?: ClientItem) => any;
	billing: BillingItem[];
	identityService: IdentityService;
	changeStatus: (cancel?: boolean) => () => void;
	taxes: TaxSummary[];
	reloadQuote: () => Promise<void>;
	rowCss: string;
	getOccupancy: (entry: QuoteEntryItem) => PersonOccupancy[];
	getSearchParameter: (entry: QuoteEntryItem, occupancies: Occupancy[]) => Search;
	deletePaxs: (paxsDelete: QuotePaxItem[]) => Promise<boolean>;
	showAlert: boolean;
	updateAgentCommissions: () => Promise<void>;
	updateDependentQuoteEntries: (quoteEntries?: QuoteEntryItem[]) => Promise<void>;
	updateFees: () => Promise<void>;
	updatePrice: (quoteEntries: QuoteEntryItem[], newMarketId?: number, newBookingDate?: Date) => Promise<boolean>;
	updateQuote: (items?: QuoteEntryItem[]) => void;
	handleEditQuotePaxField: (quotePax: QuotePaxItem, requireUpdatePrice: boolean, requirePolicyChecking: boolean) => Promise<void>;
	erratas: ErratasQuoteEntryItem[];
	erratasService: any;
	erratasConfirmed: ErratasQuoteEntryItemConfirmed[];
	showModalErratasConfirmation: boolean;
	depositPercent: number;
	dueDateInDays: number;
	onMarketChange: (selected: MarketSummary) => void;
	currencyCode: string;
	currencyId: number;
	openInitialDeposit: boolean;
	onSubmitPayment: (paymentInfo: PaymentInfo, immediatelyPerformPayment: boolean) => Promise<void>;
	closeInitialDepositDialog: () => void;
	onAgentChange: (agent: AgentSummary) => Promise<void>;
	onPaymentModeChange: (paymentMode: number) => Promise<void>;
	autoconnetProductsConfig: { products: AutoConnetProductConfig[] }
	useAllotmentBeforeBookings:boolean
}

interface QuoteFormViewState {
	isValid: boolean;
	userTaskCount: number;
}

@observer
export class QuoteFormView extends React.Component<QuoteFormViewProps, QuoteFormViewState> {

	private permissions = ['Quote', 'Quote_Write', 'Quote_Write_Own'];

	constructor(props: Readonly<QuoteFormViewProps>) {
		super(props);

		this.state = { isValid: false, userTaskCount: 0 };
	}

	componentWillReceiveProps(nextProps: Readonly<QuoteFormViewProps>) {
		//if (nextProps.model != null) {
		//	this.props.model.dynamicProperties['notes'] = nextProps.model.dynamicProperties['notes'];
		//}

		this.props.model.validate(false)
			.then((errors) => {
				this.setState({ isValid: errors.length === 0 });
			});
	}

	componentDidMount(): void {
		let daedline = moment.utc().add(1, "day").toDate();
		let assignedToId = this.props.identityService.userId;
		let priority = 1;
		let titleTask = "Task Title";
		this.taskTab = new UserTaskTab(this, this.props.model.id, 'quote', this.props.setBusy, daedline, assignedToId, priority, titleTask);
	}

	@autobind
	private handleUpdatePricesOnGeneralChanges(newMarketId?: number, newBookingDate?: Date): Promise<boolean> {
		const { updatePrice } = this.props;

		return updatePrice(null, newMarketId, newBookingDate);
	};

	@autobind
	AllErratasAreConfirmed() {
		return this.props.erratasConfirmed.every(x => x.confirmed);
	}

	@autobind
	private acceptErratasConfirmDialog(ev?: React.MouseEvent<HTMLButtonElement>) {
		if (ev != null) {
			ev.preventDefault();
		}
		if (this.AllErratasAreConfirmed) {// actualizar la lista de los quote entry 
			for (let confirmed of this.props.erratasConfirmed) {
				let entry = this.props.entryDataService.items.find(x => x.id == confirmed.quoteEntryId);
				if (entry) {
					if (entry.dynamicProperties.erratasConfirmed == null)
						entry.dynamicProperties.erratasConfirmed = [];
					let errataFromEntry = entry.dynamicProperties.erratasConfirmed.find(x => x.id == confirmed.errata.id);
					if (errataFromEntry == null)
						entry.dynamicProperties.erratasConfirmed.push(confirmed.errata);
				}
			}
		}
	}

	erratasConfirmColumns: Column[] = [
		{
			key: 'product',
			dataIndex: 'product',
			render: (text: any, record: ErratasQuoteEntryItemConfirmed, index: number) => {
				const product = this.props.entryDataService.items.find(e => e.id === record.quoteEntryId);
				return product ? product.productDisplayName : "";
			},
			title: 'Product',
		},
		{
			key: 'title',
			dataIndex: 'title',
			render: (text: any, record: ErratasQuoteEntryItemConfirmed, index: number) => {
				return record.errata.title;
			},
			title: 'Title',
		},
		{
			key: 'ErrataText',
			dataIndex: 'ErrataText',
			editable: (text: any, record: ErratasQuoteEntryItemConfirmed, index: number, isSelected: boolean) => {
				return <RichTextView
					containerClassName="wysiwyg-editor-wrap-content"
					label={null}
					value={record.errata.html}
					onChanged={(html) => { record.errata.html = html }}
					mode={"display"}
				/>
			},
			title: 'Errata Text',
			width: '50%'
		},
		{
			key: 'ConfirmedLecture',
			dataIndex: 'ConfirmedLecture',
			editable: (text: any, record: ErratasQuoteEntryItemConfirmed, index: number, isSelected: boolean) => {
				return <BooleanView
					mode="edit"
					value={record.confirmed}
					onChanged={newVal => {
						record.confirmed = newVal;
						let entry = this.props.entryDataService.items.find(x => x.id == record.quoteEntryId);
						if (entry) {
							if (entry.dynamicProperties.erratasConfirmed == null)
								entry.dynamicProperties.erratasConfirmed = [];
							let errataFromEntry = entry.dynamicProperties.erratasConfirmed.find(x => x.id == record.errata.id);
							if (record.confirmed == true && errataFromEntry == null) {
								entry.dynamicProperties.erratasConfirmed.push(record.errata);
							}
							else if (record.confirmed == false && errataFromEntry != null) {
								let index = entry.dynamicProperties.erratasConfirmed.findIndex(errataFromEntry);
								entry.dynamicProperties.erratasConfirmed.splice(index, 1);
							}


						}

					}}
				/>
			},
			title: 'Confirmed Lecture',
			width: '100px'
		}
	];

	private get erratasConfirmDataSet(): DataLocalService<any> {
		return new DataLocalService(this.props.erratasConfirmed);
	}
	@autobind
	renderModalErrataConfirmation() {
		if (this.props.erratasConfirmed == null || this.props.erratasConfirmed.length == 0)
			return null;
		return <Modal
			style={{ top: 20 }}
			width="80%"
			visible={this.props.showModalErratasConfirmation}
			onCancel={this.acceptErratasConfirmDialog}
			title="Confirmation for Erratas"
			maskClosable={false}
		>
			{
				this.props.erratasConfirmed && <DataTableView
					mode="edit"
					rowKey="quoteEntryId"
					setBusy={this.props.setBusy}
					columns={this.erratasConfirmColumns}
					model={this.erratasConfirmDataSet}
					hideToolbar={ToolbarVisibility.hideSearch | ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hidePagination}
					selection={false}
				/>

			}
		</Modal>
	}


	taskTab: UserTaskTab;

	render(): React.ReactNode {
		if (this.props.model == null) {
			return null;
		}
		const isReadonly = !this.permissions.some((r) => this.props.identityService.isAuthorized(r));
		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				{this.renderModalErrataConfirmation()}
				<Row>
					<Col xs={24}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={this.props.title}
									mode={this.props.mode}
									onModeChanged={this.props.onModeChanged}
									save={this.props.save}
									cancel={this.props.cancel}
									hideModifyButtons={isReadonly}
									contextService={this.props.contextService}
								/>
								{
									this.props.showAlert &&
									<Alert
										showIcon
										message="Warning"
										description="There are travelers not assigned to at least one product"
										type="warning"
										style={{ marginBottom: '3px' }}
									/>
								}
							</Col>
						</Row>
						<Row>
							<Col xs={24}>
								<div className="card p-3">
									<Tabs defaultActiveKey={this.props.model.id < 0 ? "General information" : "entry"}>
										<TabPane tab={<span><ZuluIcon type="book" />General information</span>} key="General information" forceRender={true}>
											<QuoteGeneralPartController
												contextService={this.props.contextService}
												newQuotePax={this.props.newQuotePax}
												mode={this.props.mode}
												model={this.props.model}
												setBusy={this.props.setBusy}
												changeStatus={this.props.changeStatus}
												paxes={this.props.paxDataService.items}
												updateFees={this.props.updateFees}
												updatePrice={this.handleUpdatePricesOnGeneralChanges}
												depositPercent={this.props.depositPercent}
												onMarketChange={this.props.onMarketChange}
												dueDateInDays={this.props.dueDateInDays}
												onSubmitPayment={this.props.onSubmitPayment}
												closeInitialDepositDialog={this.props.closeInitialDepositDialog}
												openInitialDeposit={this.props.openInitialDeposit}
												onAgentChange={this.props.onAgentChange}
												onPaymentModeChange={this.props.onPaymentModeChange}
												currencyId={this.props.currencyId}
												currencyCode={this.props.currencyCode}
											/>
										</TabPane>
										<TabPane tab={<span><ZuluIcon type="team" />Paxs</span>} key="pax">
											<Row>
												<Col xs={24}>
													<QuotePaxController
														dataService={this.props.paxDataService}
														formatService={this.props.formatService}
														mode={this.props.mode}
														onModeChanged={this.props.onModeChanged}
														model={this.props.model}
														contextService={this.props.contextService}
														setBusy={this.props.setBusy}
														billing={this.props.billing}
														newQuotePax={this.props.newQuotePax}
														deletePaxs={this.props.deletePaxs}
														handleEditQuotePaxField={this.props.handleEditQuotePaxField}
														identityService={this.props.identityService}
														defaultLanguage={this.props.defaultLanguage}
													/>
												</Col>
											</Row>
										</TabPane>
										<TabPane tab={<span><ZuluIcon type="shopping" />Products</span>} key="entry">
											<Row>
												<Col xs={24}>
													<QuoteEntryController
														erratasConfirmed={this.props.erratasConfirmed}
														model={this.props.model}
														dataService={this.props.entryDataService}
														formatService={this.props.formatService}
														mode={this.props.mode}
														contextService={this.props.contextService}
														setBusy={this.props.setBusy}
														taxes={this.props.taxes}
														paxs={this.props.paxDataService.items}
														reloadQuote={this.props.reloadQuote}
														rowCss={this.props.rowCss}
														getOccupancy={this.props.getOccupancy}
														getSearchParameter={this.props.getSearchParameter}
														updateCommissions={this.props.updateAgentCommissions}
														updateDependantQuoteEntries={this.props.updateDependentQuoteEntries}
														updatePrice={this.props.updatePrice}
														updateQuote={this.props.updateQuote}
														erratas={this.props.erratas}
														erratasService={this.props.erratasService}
														currencyCode={this.props.currencyCode}
														autoconnetProductsConfig={this.props.autoconnetProductsConfig}
														useAllotmentBeforeBookings={this.props.useAllotmentBeforeBookings}
													/>
												</Col>
											</Row>
										</TabPane>
										<TabPane tab={<span><ZuluIcon type="file" />Documents</span>} key="documents">
											<DocumentGenerationController
												mode={isReadonly ? 'display' : 'edit'}
												contextService={this.props.contextService}
												usage="Quotes"
												generationEnabled={this.props.generationEnabled}
												containerId={this.props.model.documentsLibraryId}
												targetId={this.props.model.id}
												setBusy={this.props.setBusy}
												marketId={this.props.model.marketId}
												brandId={this.props.model.brandId}
											/>
										</TabPane>
										{this.taskTab && this.taskTab.render()}
										<TabPane tab={<Badge style={{ right: '-15px', marginTop: '5px' }} count={this.props.paymentDataSet.count}><span><ZuluIcon type="credit-card" /> Payments</span></Badge>} key="payments">
											<QuotePaymentListController
												mode={this.props.mode}
												model={this.props.model}
												currencyId={this.props.currencyId}
												currencyCode={this.props.currencyCode}
												paxDataSet={this.props.paxDataService}
												paymentDataSet={this.props.paymentDataSet}
												onSubmitPayment={this.props.onSubmitPayment}
												reloadQuote={this.props.reloadQuote}
												setBusy={this.props.setBusy}
											/>
										</TabPane>
										<TabPane tab={<span><ZuluIcon type="clock-circle" />History</span>} key='history'>
											<AuditController
												type='quote'
												modelIdPreffix="Quote"
												modelId={this.props.model.entity.uniqueId}
											/>
										</TabPane>
										<TabPane tab={<Badge style={{ right: '-15px', marginTop: '5px' }} count={this.props.model.dynamicProperties['notes'] ? this.props.model.dynamicProperties['notes'].length : undefined}><span><ZuluIcon type="book" /> Notes</span></Badge>} key="notes">
											<NoteListController
												isModal={false}
												model={this.props.model.dynamicProperties['notes']}
												mode={this.props.mode}
												identityService={this.props.identityService}
												setBusy={this.props.setBusy}
											/>
										</TabPane>
									</Tabs>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quotes/form/quote-form.view.tsx